import { startCase, isEmpty } from 'lodash'
import SigCard from 'core/components/SigCard'
import SigKeyValue from 'core/components/SigKeyValue'
import {
  DEVICE_ENTRY_NO_DATA,
  DEVICE_ENTRY_NO_INFO,
} from 'caseReport/Constants'
import SigKeyValueGroup from '../../../../core/components/SigKeyValueGroup/SigKeyValueGroup'
import SigCardCollapse from '../../../../core/components/SigCardCollapse'
import { FC } from 'react'
import {
  Device,
  DeviceDetails,
  OakDeviceDetails,
} from 'core/http/cases/EntriesHttp.types'

const { Panel } = SigCardCollapse

const ROLE_LABELS: Record<string, string> = {
  oakDeviceFingerprint: 'Oak Device Fingerprint',
  tmxDeviceFingerprint: 'Tmx Device Fingerprint',
}

interface Props {
  deviceInfo: Array<Device>
}

const DeviceEntry: FC<Props> = ({ deviceInfo }) => {
  const deviceProperties = (deviceDetails: DeviceDetails | OakDeviceDetails) =>
    Object.entries(deviceDetails)
      // Stringified so SigKeyValue doesn't drop false/0 as falsy.
      .filter(
        ([, value]) =>
          typeof value === 'boolean' ||
          typeof value === 'number' ||
          !!value?.length
      )
      .map(([key, value]) => {
        const displayValue = String(value)

        return {
          name: startCase(key),
          value: displayValue,
          copyValue: displayValue,
          alignValueToRight: true,
        }
      })

  return (
    <SigCard title="Device" inner>
      {isEmpty(deviceInfo) && DEVICE_ENTRY_NO_DATA}
      {deviceInfo?.map((item) => {
        return (
          <SigCardCollapse key={item.uuid} defaultActiveKey={['root']}>
            <Panel
              header={
                <SigKeyValue
                  bordered={false}
                  name={ROLE_LABELS[item.role] ?? startCase(item.role)}
                  alignValueToRight
                  value={item.entityName}
                  copyValue={item.entityName}
                  seeder={item.seeder}
                />
              }
              key="root"
            >
              {deviceProperties(item.details).length >= 1 ? (
                <SigKeyValueGroup
                  title="Device Info"
                  properties={deviceProperties(item.details)}
                  hideLastItemBorder
                />
              ) : (
                <SigKeyValue
                  name={DEVICE_ENTRY_NO_INFO}
                  bordered={false}
                  isNameBold={false}
                />
              )}
            </Panel>
          </SigCardCollapse>
        )
      })}
    </SigCard>
  )
}

export default DeviceEntry
